<app-loading *ngIf="contentReady"></app-loading>
<div class="container mb-4">
  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-lg-5 col-md-8 col-sm-12">
      <h2 class="logintext">{{ "Set New Password" | translate }}</h2>
      <form class="form" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label class="label" for="old_password">{{
            "Old Password" | translate
          }}</label>
          <input
            class="input"
            id="oldPassword"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="old_password"
            placeholder="{{ 'Old Password' | translate }}"
            [ngClass]="{
              'is-invalid':
              changePasswordForm.controls['old_password'].touched &&
              changePasswordForm.controls['old_password'].errors,
              'is-valid':
              changePasswordForm.controls['old_password'].touched &&
              changePasswordForm.controls['old_password'].errors == null ,
              'is-touched':
              changePasswordForm.controls['old_password'].untouched &&
              changePasswordForm.controls['old_password'].errors == null,
          }"
          />
        </div>
        <div class="form-group">
          <label class="label" for="Password">{{
            "Password" | translate
          }}</label>
          <input
            class="input"
            id="Password"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="new_password"
            placeholder="{{ 'Password' | translate }}"
            [ngClass]="{
              'is-invalid':
              changePasswordForm.controls['new_password'].touched &&
              changePasswordForm.controls['new_password'].errors,
              'is-valid':
              changePasswordForm.controls['new_password'].touched &&
              changePasswordForm.controls['new_password'].errors == null ,
              'is-touched':
              changePasswordForm.controls['new_password'].untouched &&
              changePasswordForm.controls['new_password'].errors == null,
          }"
          />
        </div>
        <div class="form-group">
          <label class="label" for="confirmPassword">{{
            "Confirm Password" | translate
          }}</label>
          <input
            class="input"
            id="confirmPassword"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="new_password_confirmation"
            placeholder="{{ 'Confirm Password' | translate }}"
            [ngClass]="{
              'is-invalid':
              changePasswordForm.controls['new_password_confirmation'].touched &&
              changePasswordForm.controls['new_password_confirmation'].errors,
              'is-valid':
              changePasswordForm.controls['new_password_confirmation'].touched &&
              changePasswordForm.controls['new_password_confirmation'].errors == null ,
              'is-touched':
              changePasswordForm.controls['new_password_confirmation'].untouched &&
              changePasswordForm.controls['new_password_confirmation'].errors == null,
          }"
          />
          <button
            type="button"
            class="hidePasswordBtn"
            (click)="togglePasswordVisibility()"
          >
            @if(!isPasswordVisible){
            {{ "Show Password" | translate }}
            } @else {
            {{ "Hide Password" | translate }}
            }
          </button>
        </div>
        <button type="submit" class="submit-btn login">
          {{ "Send" | translate }}
        </button>
      </form>
    </div>
  </div>
</div>

